import React, { useEffect, useRef, useState } from 'react';
import Recaptcha from 'react-google-recaptcha';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Dialog from '@material-ui/core/Dialog';
import { RECAPTCHA_SITE_KEY } from 'config/envVariable';
import Cookies from 'js-cookie';

export default function DialogReCaptcha({ onOpen = () => {}, onComplete = () => {} }) {
    const recaptchaRef = useRef(null);
    const dialogRef = useRef(null);
    const dialogContentRef = useRef(null);
    const [isLoaded, setLoaded] = useState(false);
    const [containerPosition, setContainerPosition] = useState({});

    const handleRecaptchaChange = token => {
        handleDialogClose();
        Cookies.set('reTkn', token);
        onComplete(token);
    };

    const handleDialogClose = () => {
        onOpen(false);
    };

    const resetRecaptcha = () => {
        if (recaptchaRef.current) recaptchaRef.current.reset();
    };

    const handleOnLoad = () => {
        setLoaded(true);
    };

    useEffect(() => {
        if (isLoaded) {
            const { height: dialogHeight, width: dialogWidth } =
                dialogRef?.current?.getBoundingClientRect() || {};
            const { height: dialogContentHeight, width: dialogContentWidth } =
                dialogContentRef?.current?.getBoundingClientRect() || {};
            const remainWidth = dialogWidth - dialogContentWidth;
            const remainHeight = dialogHeight - dialogContentHeight;
            const limitRate = 2;

            /**
             * 計算可變動的距離 ( 定位點會是 0，負數會向左、向上，正數會向右、向下 )
             * 利用剩餘空間來計算，來避免 dialog 超出畫面
             *
             * (Math.random() * 2 - 1)：取得 -1 ~ 1 的亂數
             * remainHeight / 2：可移動的數值。（因正負數值所以除 2 )
             * limitRate：限縮極大極小值，避免 dialog 變動位置過大，影響 UX 體驗
             */
            let top = ((Math.random() * 2 - 1) * (remainHeight / 2)) / limitRate;
            let left = ((Math.random() * 2 - 1) * (remainWidth / 2)) / limitRate;
            setContainerPosition({ top, left });
        }
    }, [isLoaded]);

    return (
        <Dialog
            css={dialogStyle(containerPosition)}
            onClick={e => e.stopPropagation()}
            open
            ref={dialogRef}
        >
            <div css={dialogContentWrapperStyle} id="re-captcha-container" ref={dialogContentRef}>
                <Recaptcha
                    asyncScriptOnLoad={handleOnLoad}
                    ref={recaptchaRef}
                    onErrored={resetRecaptcha}
                    onExpired={resetRecaptcha}
                    onChange={handleRecaptchaChange}
                    sitekey={RECAPTCHA_SITE_KEY}
                    hl={i18n.language}
                />
            </div>
        </Dialog>
    );
}

const dialogStyle = ({ top = 0, left = 0 }) => css`
    & .MuiBackdrop-root {
        z-index: 1000;
    }

    & .MuiDialog-paper {
        top: ${top}px;
        left: ${left}px;
    }

    & .MuiDialog-container {
        position: relative;
        z-index: 1100;
    }
`;

const dialogContentWrapperStyle = css`
    width: 320px;
    min-height: 84px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
